import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PolicyOverview from "./sections/PolicyOverview";
import CollecteDeDonnees from "./sections/CollecteDeDonnees";
import UserRightsAndChildrensPrivacy from "./sections/UserRightsAndChildrensPrivacy";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PolicyOverview />
      <CollecteDeDonnees />
      <UserRightsAndChildrensPrivacy />
      <Footer />
    </div>;
}